export default __webpack_public_path__ + "746b801a29bf790613fe3f6d2861b2d4.gif";